import React from "react";
import { FiMenu, FiUser, FiHome } from "react-icons/fi";
import { FaEdit } from "react-icons/fa";
import { useClearChat } from "../contexts/ClearChatContext";

const MobileTopbar = ({
  onMenuClick,
  showMenuButton = true,
  showProfileButton = false,
  onProfileClick,
  onHeadingClick,
  onHomeClick,
  showHomeButton = true,
  showEditButton = false,
}) => {
  const handleHomeClick = onHomeClick ?? onHeadingClick;
  const { triggerClearChat, hasActiveChat } = useClearChat();

  return (
    <div className="md:hidden sticky top-0 z-40 bg-white/90 backdrop-blur border-b border-gray-200">
      <div className="flex items-center justify-between h-12 px-3">
        <div className="flex items-center gap-2 min-w-[92px]">
          {showHomeButton ? (
            <button
              aria-label="Go to tutor"
              onClick={handleHomeClick}
              className="p-2 rounded-md text-gray-700 hover:bg-gray-100 active:bg-gray-200"
            >
              <FiHome className="w-6 h-6" />
            </button>
          ) : (
            <div className="w-10" />
          )}
          {showMenuButton ? (
            <button
              aria-label="Open menu"
              onClick={onMenuClick}
              className="p-2 rounded-md text-gray-700 hover:bg-gray-100 active:bg-gray-200"
            >
              <FiMenu className="w-6 h-6" />
            </button>
          ) : (
            <div className="w-10" />
          )}
        </div>
        <button
          type="button"
          aria-label="Go to tutor"
          onClick={onHeadingClick}
          className="text-primary text-lg font-semibold select-none"
        >
          <span className="font-bold">A</span>
          <span>anya</span>
        </button>
        <div className="flex items-center gap-2">
          {/* {showEditButton && hasActiveChat && (
            <button
              aria-label="New Chat"
              onClick={triggerClearChat}
              className="p-2 rounded-md text-gray-700 hover:bg-gray-100 active:bg-gray-200"
            >
              <FaEdit className="w-6 h-6" />
            </button>
          )} */}
          {showProfileButton ? (
            <button
              aria-label="Go to profile"
              onClick={onProfileClick}
              className="p-2 rounded-md text-gray-700 hover:bg-gray-100 active:bg-gray-200"
            >
              <FiUser className="w-6 h-6" />
            </button>
          ) : (
            <div className="w-10" />
          )}
        </div>
      </div>
    </div>
  );
};

export default MobileTopbar;
